__turbopack_context__.v({
  "form-section": "form-section-module-scss-module__ZWIDRq__form-section",
  "section": "form-section-module-scss-module__ZWIDRq__section",
});
